
import { useTranslation } from "react-i18next";
import PageHero from "@/components/Layout/PageHero";

const PricingHeader = () => {
  const { t } = useTranslation('pricing');
  
  return (
    <PageHero
      title={t('title')}
      description={t('subtitle')}
      contentClassName="py-12 md:py-16"
    />
  );
};

export default PricingHeader;
